import { RSAA } from "redux-api-middleware";
import { fetchCalendarAction } from "../Calendar/calendarActions";
import { changeMenu, getMenuSelector } from "../GamesMenu/gameMenuActions";
import appHistory from "../appHistory";
import {
  setEntriesOwnAction,
  setRankingAction,
} from "../Ranking/rankingReducer";
import {
  SET_HAS_SUBLEAGUES,
  setHasSubleagues,
} from "../Core/Actions/mobileActions";

export const GAME_LOADING = "GAME/LOADING";
export const GAME_SET = "GAME_SET";
export const GAMES_UPDATE = "GAMES_UPDATE";
export const GAME_REDIRECT_SET = "GAME_REDIRECT_SET";
export const PAGE_SET = "PAGE_SET";
export const SEARCH_SET = "SEARCH_SET";
export const SPORTSMEN_REDUCER_RESET = "SPORTSMEN_REDUCER_RESET";

export const fetchEntriesOwnAction =
  (classificationId, gameId) => (dispatch, getState) => {
    if (!getState().user.loggedIn) {
      return false;
    }

    dispatch({
      [RSAA]: {
        endpoint: `/api/v1/my/game/${gameId}/classification/${classificationId}/entries`,
        method: "GET",
        credentials: "same-origin",
        headers: {
          "X-Currency": getState().user.currency,
        },
        types: [
          "REQUEST",
          {
            type: "SUCCESS",
            payload: (action, state, res) =>
              res
                .json()
                .then((json) =>
                  dispatch(
                    setEntriesOwnAction(classificationId, json.data.entries)
                  )
                ),
          },
          "FAILURE",
        ],
      },
    });
  };

export const initLoad = () => (dispatch, getStore) => {
  let game = getStore().gamesMenu.current
    ? getStore().gamesMenu.current.value.games[0]
    : null;
  if (game) {
    goToGame(game);
    return;
  }

  if (getStore().user.loggedIn) {
    dispatch(changeMenu({ status: "live", scope: "all" })).then(() => {
      const menu = getMenuSelector(getStore, "live", "all");

      let game = menu.value.games[0];
      if (game) {
        goToGame(game);
      }
    });
  }
};

function goToGame(game) {
  return appHistory.push(`/results/${game.id}`);
}

export const fetchGameInfoAction = (game) => (dispatch, getState) =>
  dispatch({
    [RSAA]: {
      endpoint: `/api/v1/game/${game.id}/info`,
      method: "GET",
      credentials: "same-origin",
      headers: {
        "X-Currency": getState().user.currency,
      },
      types: [
        GAME_LOADING,
        {
          type: "GAME/GET-INFO/SUCCESS",
          payload: (action, state, res) =>
            res.json().then((json) => {
              if (json.data && json.data.hasOwnProperty("hasSubLeagues")) {
                dispatch(setHasSubleagues(json.data.hasSubLeagues));
              }

              if (json.data.type === "game-info-classifications") {
                dispatch(
                  setGameAction(
                    {
                      ...json.relationships.game,
                      ticketImg: json.data.ticket,
                      url: json.data.url,
                      prizes: json.relationships.prizes,
                    },
                    {
                      general: json.data.general,
                      stages: json.data.stages,
                    },
                    json.relationships.links,
                    json.relationships.strings,
                    json.meta,
                    json.data.hasOpenSubLeagues,
                    json.data.hasSubLeagues
                  )
                );
                dispatch(
                  setRankingAction(
                    json.relationships.ranking,
                    json.relationships.result,
                    json.relationships.ranking.entries
                  )
                );
                dispatch(
                  fetchEntriesOwnAction(
                    json.relationships.ranking.classificationId,
                    json.relationships.game.id
                  )
                );

                if (
                  json.relationships.ranking.classificationId &&
                  (
                    json.meta.calendar ||
                    json.relationships.result.showLiveUpdate
                  )
                ) {
                  dispatch(
                    fetchCalendarAction(
                      json.relationships.ranking.classificationId
                    )
                  );
                }
                return;
              }
              dispatch(
                setGameAction(
                  game,
                  null,
                  null,
                  null,
                  null,
                  json.data.hasOpenSubLeagues,
                  json.data.hasSubLeagues
                )
              );
              dispatch(setRankingRedirectAction(json.data.url));
            }),
        },
        "GAME/GET-INFO/FAILURE",
      ],
    },
  });


export const fetchGameInfoActionTeamDetails = (game) => (dispatch, getState) =>
dispatch({
  [RSAA]: {
    endpoint: `/api/v1/game/${game.id}/infoTeamDetails`,
    method: "GET",
    credentials: "same-origin",
    headers: {
      "X-Currency": getState().user.currency,
    },
    types: [
      GAME_LOADING,
      {
        type: "GAME/GET-INFO-TEAM-DETAILS/SUCCESS",
        payload: (action, state, res) =>
          res.json().then((json) => {
            if (json.data && json.data.hasOwnProperty("hasSubLeagues")) {
              dispatch(setHasSubleagues(json.data.hasSubLeagues));
            }

            if (json.data.type === "game-info-classifications") {
              dispatch(
                setGameAction(
                  {
                    ...json.relationships.game,
                    ticketImg: json.data.ticket,
                    url: json.data.url,
                    prizes: json.relationships.prizes,
                  },
                  {
                    general: json.data.general,
                    stages: json.data.stages,
                  },
                  json.relationships.links,
                  json.relationships.strings,
                  json.meta,
                  json.data.hasOpenSubLeagues,
                  json.data.hasSubLeagues
                )
              );
              dispatch(
                setRankingAction(
                  json.relationships.ranking,
                  json.relationships.result,
                  json.relationships.ranking.entries
                )
              );
              dispatch(
                fetchEntriesOwnAction(
                  json.relationships.ranking.classificationId,
                  json.relationships.game.id
                )
              );

              if (
                json.relationships.ranking.classificationId &&
                (
                  json.meta.calendar ||
                  json.relationships.result.showLiveUpdate
                )
              ) {
                dispatch(
                  fetchCalendarAction(
                    json.relationships.ranking.classificationId
                  )
                );
              }
              return;
            }
            dispatch(
              setGameAction(
                game,
                null,
                null,
                null,
                null,
                json.data.hasOpenSubLeagues,
                json.data.hasSubLeagues
              )
            );
            dispatch(setRankingRedirectAction(json.data.url));
          }),
      },
      "GAME/GET-INFO-TEAM-DETAILS/FAILURE",
    ],
  },
});



export const setGameAction = (
  game,
  classifications,
  links,
  strings,
  meta,
  hasOpenSubLeagues,
  hasSubLeagues
) => ({
  type: GAME_SET,
  payload: {
    game: game,
    classifications,
    links,
    strings,
    meta,
    hasOpenSubLeagues,
    hasSubLeagues,
  },
});

const setRankingRedirectAction = (url) => ({
  type: GAME_REDIRECT_SET,
  payload: {
    url: url,
  },
});

export const fetchClassificationAction =
  (classification) => (dispatch, getState) => {
    const state = getState();
    if (state.ranking.cache[classification.id]) {
      dispatch(
        setRankingAction(
          state.ranking.cache[classification.id],
          state.ranking.cache[classification.id].result,
          state.ranking.cache[classification.id].entries[1],
          true
        )
      );
      if (
        state.games.meta.calendar ||
        state.ranking.result.showLiveUpdate
      ) {
        dispatch(fetchCalendarAction(classification.id));
      }
      return;
    }
    dispatch({
      [RSAA]: {
        endpoint: `/api/v1/game/${getState().games.current.id}/classification/${
          classification.id
        }/ranking`,
        method: "GET",
        credentials: "same-origin",
        headers: {
          "X-Currency": getState().user.currency,
        },
        types: [
          "REQUEST",
          {
            type: "SUCCESS",
            payload: (action, state, res) =>
              res.json().then((json) => {
                dispatch(
                  setRankingAction(
                    json.data,
                    json.relationships.result,
                    json.data.entries
                  )
                );
                dispatch(
                  fetchEntriesOwnAction(
                    classification.id,
                    state.games.current.id
                  )
                );

                if (
                  state.games.meta.calendar ||
                  state.ranking.result.showLiveUpdate
                ) {
                  dispatch(fetchCalendarAction(classification.id));
                }
              }),
          },
          "FAILURE",
        ],
      },
    });
  };

const setPageAction = (
  classificationId,
  page,
  entries,
  search,
  fromCache = false
) => ({
  type: PAGE_SET,
  payload: {
    entries: entries,
    page: page,
    classificationId: classificationId,
    search: search,
  },
  fromCache: fromCache,
});

export const fetchPageAction =
  (classification, pageIndex, useSearch = true) =>
  (dispatch, getState) => {
    const state = getState();
    const search = (useSearch && state.ranking.search) || null;

    if (
      !search &&
      state.ranking.cache[classification.id] &&
      state.ranking.cache[classification.id].entries[pageIndex]
    ) {
      dispatch(
        setPageAction(
          classification.id,
          pageIndex,
          state.ranking.cache[classification.id].entries[pageIndex],
          null,
          true
        )
      );
      return;
    }
    let endpoint = !search
      ? `/api/v1/game/${getState().games.current.id}/classification/${
          classification.id
        }/ranking/page/${pageIndex}`
      : `/api/v1/game/${getState().games.current.id}/classification/${
          classification.id
        }/ranking/search/${search}/${pageIndex}`;

    dispatch({
      [RSAA]: {
        endpoint,
        method: "GET",
        credentials: "same-origin",
        headers: {
          "X-Currency": getState().user.currency,
        },
        types: [
          "REQUEST",
          {
            type: "SUCCESS",
            payload: (action, state, res) =>
              res
                .json()
                .then((json) =>
                  dispatch(
                    setPageAction(
                      classification.id,
                      pageIndex,
                      json.data.entries,
                      search
                    )
                  )
                ),
          },
          "FAILURE",
        ],
      },
    });
  };

export const searchAction =
  (classification, search) => (dispatch, getState) => {
    if (!search) {
      dispatch(fetchClassificationAction(classification));
      return;
    }

    return dispatch({
      [RSAA]: {
        endpoint: `/api/v1/game/${getState().games.current.id}/classification/${
          classification.id
        }/ranking/search/${search}`,
        method: "GET",
        credentials: "same-origin",
        headers: {
          "X-Currency": getState().user.currency,
        },
        types: [
          "REQUEST",
          {
            type: SEARCH_SET,
            payload: (action, state, res) =>
              res.json().then((json) => ({ ...json.data, search })),
          },
          "FAILURE",
        ],
      },
    });
  };
